module.exports = {
	"articleTitle1": "Lila Kalick - ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Bandito's",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/opinion/11viewpoint-new-east-quad-sucks11",
	"articleSnippet1": "Dec 1, 2010 ... Likewise, the burritos at Bandito's on South Fourth Street are just plain weak. On \nthe high end, the Prickly Pear on South Main Street offers the ...",
	"articleSnippet2": "",
	"foodRecommendations": [
		{
			"text": "Not the chain restaurant.",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "",
	"address": "216 S 4th Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2799,
		"lng": -83.7476
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/banditos.json
// module id = 821
// module chunks = 0